import { render, staticRenderFns } from "./w-jakie-surowce-inwestowac.md?vue&type=template&id=6d3052d1&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports